import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  ItemCard, ItemHeader, BadgeRow, TypeBadge, ItemTitle, LicenseBadge, LicenseIcon, ItemDescription, ItemActions, ActionLink, ActionIcon,
  TitleContainer
} from './styled';

const TYPE_LABEL_IDS = {
  new: 'user.whatsNew.item.type.new',
  improvement: 'user.whatsNew.item.type.improvement',
  fix: 'user.whatsNew.item.type.fix',
  unknown: 'user.whatsNew.item.type.unknown'
};

const LICENSE_BADGES = {
  professional: ['corporate', 'professional'],
  corporate: ['corporate']
};

const linkProps = (link, onQuickTour) => (
  link.type === 'tour'
    ? { as: 'button', type: 'button', onClick: () => onQuickTour(link.url) }
    : { href: link.url, target: '_blank', rel: 'noopener noreferrer' }
);

const WhatsNewItem = ({ item, onQuickTour }) => {
  const intl = useIntl();
  const {
    type, title, description, license, link
  } = item;

  return (
    <ItemCard>
      <ItemHeader>
        <TitleContainer>
          <TypeBadge $type={ type }>{intl.formatMessage({ id: TYPE_LABEL_IDS[type] || TYPE_LABEL_IDS.unknown })}</TypeBadge>
          <ItemTitle>{title}</ItemTitle>
        </TitleContainer>
        <BadgeRow>
          {license && LICENSE_BADGES[license].map((tier) => (
            <LicenseBadge key={ tier } $license={ tier }>
              <LicenseIcon />
              {intl.formatMessage({ id: `user.whatsNew.license.${tier}` })}
            </LicenseBadge>
          ))}
        </BadgeRow>
      </ItemHeader>
      <ItemDescription>{description}</ItemDescription>
      {link && (
        <ItemActions>
          <ActionLink { ...linkProps(link, onQuickTour) }>
            {link.label}
            <ActionIcon />
          </ActionLink>
        </ItemActions>
      )}
    </ItemCard>
  );
};

WhatsNewItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['new', 'improvement', 'fix']).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    license: PropTypes.oneOf(['professional', 'corporate']),
    link: PropTypes.shape({
      type: PropTypes.oneOf(['tour', 'doc']).isRequired,
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  }).isRequired,
  onQuickTour: PropTypes.func.isRequired
};

export default WhatsNewItem;
